import React from 'react'
import { faqs } from '../../data';
import { FaQuestion } from "react-icons/fa6";
import Faqs2 from "./faqs2";
import SeactionHeader from '../seactionheader/SeactionHeader';


function FAQS() {
  return (
    <section className='fasqs'>
        <div className="container container__fasqs">
            <SeactionHeader icon={<FaQuestion/>} title='faqs'/>
            <div className="faqs__wrapper">
                {
                    faqs.map(({id, question, answer}) => {
                        return <Faqs2 key={id} question={question} answer={answer}/>
                    })
                }
            </div>
        </div>    

    </section>
  )
}

export default FAQS